"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = {
  name: 'HeaderSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleButton: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      default: function _default() {}
    },
    titleButtonTwo: {
      type: String,
      default: ''
    },
    actionTwo: {
      type: Function,
      default: function _default() {}
    }
  }
};
exports.default = _default2;